import React from 'react';

export const usePostMessageListener = (eventName: string, callBack: (data: unknown) => void) => {
  React.useEffect(() => {
    const messageFunction = (event: MessageEvent<unknown>) => {
      const payload = event.data;
      if (payload != null && typeof payload === 'object' && 'type' in payload && 'data' in payload) {
        if (payload.type === eventName) {
          callBack(payload.data);
        }
      }
    };
    window.addEventListener('message', messageFunction);
    return () => {
      window.removeEventListener('message', messageFunction);
    };
  }, [eventName, callBack]);
};
